<kendo-dialog title="Edit Contact Information" (close)="closeDailog()" [width]="786" [height]="'auto'"
  [maxHeight]="'90vh'" [formGroup]="form" *ngIf="form">

  <div class="loading-container" *ngIf="loadSpinner">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <div formArrayName="attendees">
    <!-- Loop over each attendee -->
    <div *ngFor="let attendee of getAttendeesControls(); let i = index" [formGroupName]="i">
      <div style="display: flex; justify-content: flex-start">
        <kendo-gridlayout class="k-mb-4">
          <kendo-gridlayout-item>

            <div [ngClass]="attendee?.value?.redAlert ? 'redAlertBorder' : ''">

              <kendo-expansionpanel [expanded]="i === 0">
                <ng-template kendoExpansionPanelTitleDirective>
                  <span class="k-expander-title">
                    {{attendee?.value?.firstName}} {{attendee?.value?.lastName}}
                    ({{attendee?.value?.relationship?.description}})
                  </span>
                  <span class="k-spacer"></span>
                  <span class="k-expander-sub-title">{{attendee?.value?.isPrimary ? 'Primary' : ''}}</span>
                  <div class="red-alert-container" *ngIf="attendee?.value?.redAlert">
                    <kendo-svg-icon [icon]="warningTriangleSvg"></kendo-svg-icon>
                    <span class="k-expander-sub-title">Red Alert</span>
                  </div>
                </ng-template>

                <div class="primary-resides-with-student-container">
                  <div>
                    <kendo-svg-icon [icon]="attendee?.value?.isPrimary ? checkMarkIcon : xMarkIcon"
                      [ngClass]="attendee?.value?.isPrimary ? 'checkMark' : 'xMark'" [size]="'large'">
                    </kendo-svg-icon>
                    <span class="bold-text">Primary</span>
                  </div>

                  <div>
                    <kendo-svg-icon [icon]="attendee?.value?.residesWithStudent === 'Y' ? checkMarkIcon : xMarkIcon"
                      [ngClass]="attendee?.value?.residesWithStudent === 'Y' ? 'checkMark' : 'xMark'" [size]="'large'">
                    </kendo-svg-icon>
                    <span class="bold-text">Resides with student</span>
                  </div>
                </div>

                <!-- Basic Information section -->
                <div class="subsection">
                  <h4 class="subsection__heading">Basic Information</h4>

                  <div class="contact-details-container">
                    <kendo-formfield class="k-w-full">
                      <kendo-floatinglabel text="Relationship *">
                        <kendo-dropdownlist [data]="referenceData?.relationship" textField="description"
                          formControlName="relationship" valueField="value">
                        </kendo-dropdownlist>
                      </kendo-floatinglabel>
                      <kendo-formerror>Required</kendo-formerror>
                    </kendo-formfield>

                    <div class="info-container">
                      <kendo-formfield>
                        <kendo-floatinglabel text="First Name *">
                          <kendo-textbox formControlName="firstName" />
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ attendee.get('firstName')?.errors?.validateName?.message
                          }}</kendo-formerror>
                      </kendo-formfield>

                      <kendo-formfield>
                        <kendo-floatinglabel text="Last Name *">
                          <kendo-textbox formControlName="lastName" />
                        </kendo-floatinglabel>
                        <kendo-formerror>{{ attendee.get('lastName')?.errors?.validateName?.message }}</kendo-formerror>
                      </kendo-formfield>
                    </div>

                    <kendo-formfield class="k-w-full">
                      <kendo-floatinglabel text="Authorization Code">
                        <kendo-dropdownlist textField="description" formControlName="authorizationCode"
                          [data]="getAuthCodeData()" valueField="value">
                        </kendo-dropdownlist>
                      </kendo-floatinglabel>
                    </kendo-formfield>
                  </div>
                </div>

                <div class="divider"></div>

                <!-- Language Section -->
                <div class="subsection">
                  <h4 class="subsection__heading">Language</h4>

                  <div class="info-container">
                    <kendo-formfield>
                      <kendo-floatinglabel text="Spoken Language">
                        <kendo-dropdownlist [data]="referenceData?.language" textField="description"
                          formControlName="spokenLanguage" valueField="value">
                        </kendo-dropdownlist>
                      </kendo-floatinglabel>
                      <kendo-formerror>{{attendee.get('cellPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
                    </kendo-formfield>

                    <kendo-formfield>
                      <kendo-floatinglabel text="Written Language">
                        <kendo-dropdownlist [data]="referenceData?.language" textField="description"
                          formControlName="writtenLanguage" valueField="value">
                        </kendo-dropdownlist>
                      </kendo-floatinglabel>
                      <kendo-formerror>{{attendee.get('workPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
                    </kendo-formfield>
                  </div>
                </div>

                <div class="divider"></div>

                <!-- Communication Section -->
                <div class="subsection">
                  <h4 class="subsection__heading">Communication</h4>

                  <div class="contact-details-container">
                    <div class="info-container">
                      <kendo-formfield>
                        <kendo-floatinglabel text="Cell Phone">
                          <kendo-maskedtextbox formControlName="cellPhone" mask="(000) 000-0000"></kendo-maskedtextbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{attendee.get('cellPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>

                      </kendo-formfield>

                      <kendo-formfield>
                        <kendo-floatinglabel text="Work Phone">
                          <kendo-maskedtextbox formControlName="workPhone" mask="(000) 000-0000"></kendo-maskedtextbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{attendee.get('workPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
                      </kendo-formfield>
                    </div>

                    <div class="info-container">
                      <kendo-formfield>
                        <kendo-floatinglabel text="Home Phone">
                          <kendo-maskedtextbox formControlName="homePhone" mask="(000) 000-0000"></kendo-maskedtextbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>{{attendee.get('homePhone')?.errors?.validatePhoneNumberMaskedTextBox?.message}}</kendo-formerror>
                      </kendo-formfield>

                      <kendo-formfield>
                        <kendo-floatinglabel text="Email">
                          <kendo-maskedtextbox formControlName="email"></kendo-maskedtextbox>
                        </kendo-floatinglabel>
                      </kendo-formfield>
                    </div>
                  </div>
                </div>

                <div class="divider"></div>

                <!-- Housing information -->
                <div class="subsection">
                  <h4 class="subsection__heading">Housing</h4>

                  <div class="contact-details-container">
                    <div class="info-container">
                      <kendo-formfield class="address-fields">
                        <kendo-floatinglabel text="Street Number *">
                          <kendo-textbox formControlName="streetNumber"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>Required</kendo-formerror>
                      </kendo-formfield>

                      <kendo-formfield>
                        <kendo-floatinglabel text="Street Name *">
                          <kendo-textbox formControlName="streetName"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>Required</kendo-formerror>
                      </kendo-formfield>

                      <kendo-formfield class="address-fields">
                        <kendo-floatinglabel text="Apartment Number">
                          <kendo-textbox formControlName="apartmentNo"></kendo-textbox>
                        </kendo-floatinglabel>
                      </kendo-formfield>
                    </div>

                    <div class="info-container">
                      <kendo-formfield class="address-fields">
                        <kendo-floatinglabel text="Home Borough *">
                          <kendo-dropdownlist formControlName="borough" textField="description"
                            [data]="referenceData?.borough" valueField="value">
                          </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Required</kendo-formerror>
                      </kendo-formfield>

                      <kendo-formfield class="address-fields">
                        <kendo-floatinglabel text="City *">
                          <kendo-textbox formControlName="city"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>Required</kendo-formerror>
                      </kendo-formfield>

                      <kendo-formfield class="address-fields">
                        <kendo-floatinglabel text="State *">
                          <kendo-dropdownlist [data]="referenceData?.state" textField="description"
                            formControlName="state" valueField="value">
                          </kendo-dropdownlist>
                        </kendo-floatinglabel>
                        <kendo-formerror>Required</kendo-formerror>
                      </kendo-formfield>

                      <kendo-formfield class="address-fields">
                        <kendo-floatinglabel text="Zip Code *">
                          <kendo-textbox formControlName="zip"></kendo-textbox>
                        </kendo-floatinglabel>
                        <kendo-formerror>Required</kendo-formerror>
                        <kendo-formhint>Formats: 12345, 12345-6789, 12345 6789, or
                          123456789</kendo-formhint>
                      </kendo-formfield>

                    </div>
                  </div>
                </div>

              </kendo-expansionpanel>

            </div>
          </kendo-gridlayout-item>
        </kendo-gridlayout>
      </div>
    </div>
  </div>

  <kendo-dialog-actions [layout]="'stretched'">
    <button kendoButton fillMode="solid" themeColor="primary" [disabled]="!form.valid || loadSpinner" (click)="save()">
      Save
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<ng-template #template>
  <div *ngFor="let parent of parentErrors">
    {{ parent.name }}
    <div *ngFor="let error of parent.errors">
      {{ error }}
    </div>
  </div>
</ng-template>